import { type SearchParams } from '@/features/shop/services/Search/types'

export const CouponsSearchQuery = 'Coupons search'
export const CouponsSearchQueryLegacy = 'Coupons search legacy'

export const ProductsSearchQuery = 'Products search'

export const BuyAgainCategoriesQuery = 'Buy again categories'

export const PurchaseHistoryQuery = 'Purchase history'

export const GlobalSearchQuery = 'Global search'

export const validSearchFilterParams: Record<keyof SearchParams, true> = {
  zip: true,
  query: true,
  sort: true,
  brands: true,
  flavors: true,
  contexts: true,
  new_deals: true,
  active_deals: true,
  coupon_only: true,
  category_id: true,
  promotion_category_id: true,
  category_ids: true,
  category_name: true,
  buy_again_query: true,
}
